module.exports = __webpack_public_path__ + "static/media/Hero_Crop.6ac039e6.png";